export default "__VITE_PUBLIC_ASSET__f601b3a7__"